import { currentOpenChatSelector, userIdSelector } from '../../selectors';
import { TThunkAction } from '../../types/redux/thunk';
import { sendUXSEvent } from '../../utils/uxs';

// Отправляем опрос:
// если текущий пользователь является инициатором чата
// если в чате есть кнопка принятия предложения (actionButton)
// если текущий пользователь не нажал на кнопку принятия предложения
//
// на desktop отправляем в момент переключения на другой чат в списке чатов
// на mobile отправляем в момент нажатия "Назад" в шапке
export const sendMailingUxfeedbackCampaign = (): TThunkAction<void> => (_, getState, context) => {
  const state = getState();
  const currentChat = currentOpenChatSelector(state);
  const userId = userIdSelector(state);
  const { users, chatMessages } = currentChat || {};

  const mailingUxfeedbackNames = context.config.get<string[]>('frontend-chats.mailingUxfeedbackNames') || [];
  const initiator = users?.find(user => user.chatRole === 'initiator');

  if (userId !== initiator?.userId) {
    return;
  }

  if (!chatMessages || !chatMessages.length || !mailingUxfeedbackNames.length) {
    return;
  }

  const hasMailing = chatMessages
    .flatMap(chatMessage => chatMessage.message.actionButtonsV3 || [])
    .some(button => {
      const buttonName = button.analyticsName;

      return buttonName ? mailingUxfeedbackNames.includes(buttonName) : false;
    });

  if (hasMailing) {
    sendUXSEvent('mailing_survey_web');
  }
};
